import React from 'react'
import { Box, Button, Paper, Typography } from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

export const isStaging = process.env.REACT_APP_ENV === 'staging'

const PRODUCTION_LOGIN_URL =
  'https://systemapp.teamcm.co.th/app-checkinout/login'

interface StagingNoticeProps {
  onContinue: () => void
}

const StagingNotice: React.FC<StagingNoticeProps> = ({ onContinue }) => {
  return (
    <Box sx={{ width: '100%', maxWidth: 520 }}>
      <Box sx={{ mb: 3, textAlign: 'center' }}>
        <img
          src={`${process.env.PUBLIC_URL}/images/logo-teamcm.webp`}
          alt="TEAM•CM"
          style={{ height: 96 }}
        />
      </Box>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 4 },
          border: '3px solid #ED6C02',
          bgcolor: '#FFF4E5',
          borderRadius: 3,
          textAlign: 'center',
        }}
      >
        <WarningAmberIcon sx={{ fontSize: 64, color: '#ED6C02' }} />
        <Typography
          variant="h4"
          sx={{ mt: 1, mb: 2, fontWeight: 700, color: '#663C00' }}
        >
          นี่คือระบบ Staging
        </Typography>
        <Typography
          variant="h6"
          sx={{
            mb: 3,
            color: '#663C00',
            '& span': { whiteSpace: 'nowrap' },
          }}
        >
          <span>ระบบนี้ใช้สำหรับทดสอบเท่านั้น</span>
          <br />
          <span>ถ้าจะเข้าใช้งาน Production</span> <span>ให้กดที่นี่</span>
        </Typography>
        <Button
          variant="contained"
          size="large"
          fullWidth
          href={PRODUCTION_LOGIN_URL}
          endIcon={<OpenInNewIcon />}
          sx={{
            py: 1.5,
            fontSize: '1.15rem',
            fontWeight: 700,
            bgcolor: '#114776',
            '&:hover': { bgcolor: '#0B3155' },
          }}
        >
          ไป Production
        </Button>
      </Paper>

      <Box sx={{ mt: 3, textAlign: 'center' }}>
        <Button
          variant="outlined"
          color="warning"
          size="large"
          onClick={onContinue}
        >
          เข้าสู่ระบบ Staging
        </Button>
      </Box>
    </Box>
  )
}

export default StagingNotice
